import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { UserProvider } from './context/UserContext';
import Login from './components/Login';
import Home from './pages/home';
import Users from './pages/users';
import MyForms from './pages/myforms';
import Organizations from './pages/organizations';
import CreateForm from './pages/createform';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import { Sidebar } from './components/Sidebar';
import ViewForms from './components/FormView/ViewForms';
import UtilCharge from './pages/UtilCharge';
import Logs from './pages/Logs';

function App() {
  const [theme, setTheme] = useState('lofi');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'lofi' ? 'dark' : 'lofi'));
  };

  const handleSidebarToggle = isOpen => {
    setSidebarOpen(isOpen);
  };

  return (
    <AuthProvider>
      <UserProvider>
        <SocketProvider>
          <div data-theme={theme} className="min-h-screen bg-base-100">
            <BrowserRouter>
              <Routes>
                {/* Ruta para el Login (sin Navbar ni Sidebar) */}
                <Route path="/login" element={<Login />} />

                {/* Rutas protegidas (con Navbar y Sidebar) */}
                <Route
                  path="/*"
                  element={
                    <div className="flex flex-col h-full">
                      {!window.parent.location.pathname.includes('view-form') && (
                        <>
                          <Navbar currentTheme={theme} toggleTheme={toggleTheme} />
                          <div
                            className={`flex flex-grow pt-16 transition-all duration-300 ${sidebarOpen ? 'ml-64' : 'ml-16'
                              }`}
                          >
                            <Sidebar
                              theme={theme}
                              onSidebarToggle={handleSidebarToggle}
                            />
                            <main className=" top-8 flex-grow p-6 bg-base-100 text-base-content">
                              <Routes>
                                <Route
                                  path="/"
                                  element={
                                    <ProtectedRoute>
                                      <Home />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/users"
                                  element={
                                    <ProtectedRoute>
                                      <Users />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/organizations"
                                  element={
                                    <ProtectedRoute>
                                      <Organizations />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/Charge"
                                  element={
                                    <ProtectedRoute>
                                      <UtilCharge />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/myforms"
                                  element={
                                    <ProtectedRoute>
                                      <MyForms />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/createform"
                                  element={
                                    <ProtectedRoute>
                                      <CreateForm />
                                    </ProtectedRoute>
                                  }
                                />
                                <Route
                                  path="/view-form/:id"
                                  element={<ViewForms />}
                                />
                                <Route
                              path="/Logs"
                              element={
                                <ProtectedRoute>
                                  <Logs />
                                </ProtectedRoute>
                              }
                            />
                              </Routes>
                            </main>
                          </div>
                        </>
                      )}
                      {window.parent.location.pathname.includes('view-form') && (
                        <main className="flex-grow p-4 bg-base-100 text-base-content">
                          <Routes>
                            <Route
                              path="/"
                              element={
                                <ProtectedRoute>
                                  <Home />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/users"
                              element={
                                <ProtectedRoute>
                                  <Users />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/organizations"
                              element={
                                <ProtectedRoute>
                                  <Organizations />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/Charge"
                              element={
                                <ProtectedRoute>
                                  <UtilCharge />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/myforms"
                              element={
                                <ProtectedRoute>
                                  <MyForms />
                                </ProtectedRoute>
                              }
                            />
                            <Route
                              path="/createform"
                              element={
                                <ProtectedRoute>
                                  <CreateForm />
                                </ProtectedRoute>
                              }
                            />
                            <Route path="/view-form/:id" element={<ViewForms />} />
                          </Routes>
                        </main>
                      )}
                    </div>
                  }
                />
              </Routes>
            </BrowserRouter>
          </div>
        </SocketProvider>
      </UserProvider>
    </AuthProvider>
  );
}

export default App;